import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../CartContext';
import { useLang } from '../i18n';

// Confirmation toast shown whenever a product is added to the cart.
// Slides up from the bottom, auto-dismisses, and re-triggers on every add
// (keyed by the add timestamp). Rendered once, inside CartProvider.
export default function CartToast() {
  const { lastAdded } = useCart();
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!lastAdded) return undefined;
    setVisible(true);
    const timer = setTimeout(() => setVisible(false), 2600);
    return () => clearTimeout(timer);
  }, [lastAdded]);

  if (!lastAdded || !visible) return null;

  return (
    <div className="mk-toast" key={lastAdded.ts} role="status" aria-live="polite">
      <span className="mk-toast-check">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </span>
      <span className="mk-toast-text">{t('mk_added_named', { name: lastAdded.name })}</span>
      <Link className="mk-toast-link" to="/cart">{t('mk_toast_view')}</Link>
    </div>
  );
}
